<template lang="html">
  <div class="image_captions">
    <p v-show="text !== 'undefined'">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: "ImageCaption",
  props:{
    text:{
      type: String,
      default: () => ""
    }
  }
}
</script>

<style lang="scss" scoped>
.image_captions{
  position: absolute;
  left: 0;
  font-family: Arial, sans-serif;
  bottom: 0;
  padding-bottom: 50px;
  width: 100%;
  height: auto;
  z-index: 700;
  color: white;
  background-color: rgba(0, 0, 0, 0.7);
  p{
    position: relative;
    left: 10%;
    width: 80%;
  }
}
</style>
